import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { GestionesPage } from '@/features/gestiones/components/gestiones-page/gestiones-page';
import { GESTIONES_TABS } from '@/features/gestiones/constants';

export const gestionesSearchSchema = z.object({
  tab: z.enum(GESTIONES_TABS).optional(),
  tipo: z.string().optional(),
  responsable: z.string().uuid().optional(),
  clientId: z.string().uuid().optional(),
  page: z.coerce.number().int().min(1).optional(),
  selectedGestionId: z.string().uuid().optional(),
});

export const Route = createFileRoute('/_app/gestiones/')({
  validateSearch: gestionesSearchSchema,
  component: GestionesPage,
});
